import React from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { calculateAge } from '../../../Registrationform/helpers/calculateAge';
import { capitalizeFirstLetter } from '../../../../utils/common';

export const AndrologyCustomerProfile = () => {
  const selectedPatientData = useSelector((state) => state.andrologyReducer.selectedPatientData);

  return (
    <div className="customer-profile">
      <h3>Customer Profile</h3>
      <div className="card" style={{padding:5}}>
  <div className="body">
    <div className="row clearfix" style={{ alignItems: 'center', marginBottom: '15px' }}>
      <div className="flex col-md-4" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <strong style={{ flexShrink: 0, width: '100px' }}>Name:</strong>
        <span style={{ flexGrow: 1 }}>{selectedPatientData.patient.partner.firstName}</span>
      </div>

      <div className="flex col-md-4" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <strong style={{ flexShrink: 0, width: '100px' }}>Age:</strong>
        <span style={{ flexGrow: 1 }}>{calculateAge(dayjs(selectedPatientData.patient.partner.dob))}</span>
      </div>

      <div className="flex col-md-4" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <strong style={{ flexShrink: 0, width: '100px' }}>Mobile:</strong>
        <span style={{ flexGrow: 1 }}>{selectedPatientData.patient.partner.phone}</span>
      </div>
    </div>

    <div className="row clearfix" style={{ alignItems: 'center', marginBottom: '15px' }}>
      <div className="flex col-md-4" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <strong style={{ flexShrink: 0, width: '100px' }}>MPI No:</strong>
        <span style={{ flexGrow: 1 }}>{selectedPatientData.patient.upid}</span>
      </div>

      <div className="flex col-md-4" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <strong style={{ flexShrink: 0, width: '100px' }}>Gender:</strong>
        <span style={{ flexGrow: 1 }}>{capitalizeFirstLetter(selectedPatientData.patient.partner.gender)}</span>
      </div>

      <div className="flex col-md-4" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <strong style={{ flexShrink: 0, width: '100px' }}>Email Id:</strong>
        <span style={{ flexGrow: 1 }}>{selectedPatientData.patient.partner.email}</span>
      </div>
    </div>

    <div className="row clearfix" style={{ alignItems: 'center', marginBottom: '15px' }}>
      <div className="flex col-md-12" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <strong style={{ flexShrink: 0, width: '100px' }}>Address:</strong>
        <span style={{ flexGrow: 1 }}>
          {selectedPatientData.patient.partner.address} {selectedPatientData.patient.partner.location.city}{' '}
          {selectedPatientData.patient.partner.location.state}{' '}
          {selectedPatientData.patient.partner.location.zip}
        </span>
      </div>
    </div>

    <div className="row clearfix" style={{ alignItems: 'center', marginTop: '30px' }}>
      <div className="flex col-md-4" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <strong style={{ flexShrink: 0, width: '100px' }}>Referred By:</strong>
        <span style={{ flexGrow: 1 }}>{selectedPatientData.patient.referral.referringPhysician}</span>
      </div>
    </div>
  </div>
</div>

    </div>
  );
};